import './../scss/style.scss';
//  import Bootstrap 
require('bootstrap');
// pure swipe events
require('pure-swipe');

import { store } from './tsaw/store'
import { WCAG } from "rytm-wcag";
import { initCommon } from './shared/common'
import { initASwap } from './aswap'
import { initTsawAjax } from './tsaw/lib/tsaw_ajax';
import { initTsawGui } from './tsaw/lib/tsaw_gui';
import { initTsawMixer } from './tsaw/lib/tsaw_mixer';
import { initImagesState } from './tsaw/lib/tsaw_images';
import { initVideoState } from './tsaw/lib/tsaw_video';
import { initCarouselNav } from './shared/carousel-nav';
import { initTsawHelpers } from './shared/tsaw-helpers';
import { initTsawNavSound } from './shared/tsaw-nav-sound'
import { initFullScreen } from './shared/fullscreen';

initTsawGui()
WCAG.init()
initCommon()
initCarouselNav()
initASwap()
initTsawAjax()
initTsawMixer()
initImagesState()
initVideoState()
initTsawHelpers() // collapse class togglers, thumb menu, keyboard nav
initTsawNavSound() // chapter sound control
initFullScreen()
